import { render, staticRenderFns } from "./VaultSignModal.vue?vue&type=template&id=2606b338&scoped=true"
import script from "./VaultSignModal.vue?vue&type=script&lang=js"
export * from "./VaultSignModal.vue?vue&type=script&lang=js"
import style0 from "./VaultSignModal.vue?vue&type=style&index=0&id=2606b338&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2606b338",
  null
  
)

export default component.exports